(() => {
  const config = document.querySelector('[data-blueguard-config]');
  if (!config || window.blueStarsGuardLoaded) return;
  window.blueStarsGuardLoaded = true;
  const variant = Number(config.dataset.variant);
  if (!variant) return;
  const rawFetch = window.fetch.bind(window);
  const root = config.dataset.root;
  let queue = Promise.resolve();
  let pendingTasks = 0;
  let lastCart = null;
  let choice = '';
  try { choice = sessionStorage.getItem('blue-stars-guard-choice') || ''; } catch {}
  const remember = value => {
    choice = value;
    try { sessionStorage.setItem('blue-stars-guard-choice', value); } catch {}
  };
  const guards = cart => cart.items.filter(item => Number(item.variant_id || item.id) === variant);
  const goods = cart => cart.items.some(item => Number(item.variant_id || item.id) !== variant);
  const busy = value => document.querySelectorAll('[data-blueguard-toggle]').forEach(input => { input.disabled = value; });
  const notice = value => document.querySelectorAll('[data-blueguard-status]').forEach(node => { node.textContent = value; });
  const paint = cart => {
    lastCart = cart;
    document.dispatchEvent(new CustomEvent('bs:cart-updated', {detail: {cart}}));
    const selected = guards(cart).length > 0;
    document.querySelectorAll('[data-blueguard-toggle]').forEach(input => { input.checked = selected; });
  };
  const request = async (path, body) => {
    const response = await rawFetch(root + path, body ? {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)} : {cache: 'no-store'});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || config.dataset.error);
    return data;
  };
  const reconcile = async cart => {
    const lines = guards(cart);
    const wanted = goods(cart) && choice === 'on';
    let changed = false;
    if (lines.length) {
      const updates = {};
      lines.forEach((item, index) => {
        const quantity = wanted && index === 0 ? 1 : 0;
        if (item.quantity !== quantity) updates[item.key] = quantity;
      });
      if (Object.keys(updates).length) { cart = await request('cart/update.js', {updates}); changed = true; }
    } else if (wanted) {
      await request('cart/add.js', {items: [{id: variant, quantity: 1}]});
      cart = await request('cart.js');
      changed = true;
    }
    paint(cart);
    return {cart, changed};
  };
  const sectionIds = () => [...new Set(['cart-drawer', 'cart-icon-bubble', document.querySelector('#main-cart-items')?.dataset.id, document.querySelector('#main-cart-footer')?.dataset.id].filter(Boolean))].slice(0,5);
  const sections = async ids => {
    const url = new URL(location.href);
    url.searchParams.set('sections', ids.join(','));
    const response = await rawFetch(url.href, {cache: 'no-store'});
    if (!response.ok) throw new Error(config.dataset.error);
    return response.json();
  };
  const render = async cart => {
    if (window.blueStarsCartExtras) { await window.blueStarsCartExtras.refresh(cart); paint(cart); return; }
    const active = document.querySelector('cart-drawer')?.classList.contains('active');
    const focus = document.activeElement?.matches('[data-blueguard-toggle]');
    const html = await sections(sectionIds());
    Object.entries(html).forEach(([id, content]) => {
      if (!content) return;
      const parsed = new DOMParser().parseFromString(content, 'text/html');
      const wrapper = document.getElementById('shopify-section-' + id);
      if (wrapper) wrapper.innerHTML = parsed.getElementById('shopify-section-' + id)?.innerHTML || content;
      else {
        const current = document.getElementById(id);
        const replacement = parsed.getElementById(id);
        if (current && replacement) current.innerHTML = replacement.innerHTML;
      }
    });
    if (active) document.querySelector('cart-drawer')?.classList.add('active');
    if (focus) document.querySelector('[data-blueguard-toggle]')?.focus();
    paint(cart);
  };
  const enqueue = task => {
    pendingTasks += 1;
    const next = queue.then(task, task);
    queue = next.catch(() => {});
    return next.finally(() => { pendingTasks -= 1; });
  };
  window.fetch = (input, init) => {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.origin);
    if (url.origin !== location.origin || !/\/cart\/(add|change|update|clear)(?:\.js)?$/.test(url.pathname)) return rawFetch(input, init);
    return enqueue(async () => {
      const response = await rawFetch(input, init);
      if (!response.ok) return response;
      try {
        const original = await response.clone().json();
        const cart = await request('cart.js');
        if (lastCart && goods(cart) && guards(lastCart).length && !guards(cart).length && !/\/add(?:\.js)?$/.test(url.pathname)) remember('off');
        const result = await reconcile(cart);
        if (!result.changed) return response;
        const refreshed = original.sections ? await sections(Object.keys(original.sections).slice(0,5)) : undefined;
        const data = original.token ? {...result.cart} : {...original};
        if (refreshed) data.sections = refreshed;
        const headers = new Headers(response.headers);
        headers.delete('content-length');
        return new Response(JSON.stringify(data), {status: response.status, statusText: response.statusText, headers});
      } catch {
        notice(config.dataset.error);
        return response;
      }
    });
  };
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-blueguard-toggle]')) return;
    const input = event.target;
    const previous = !input.checked;
    const previousChoice = choice;
    const desired = input.checked;
    busy(true);
    enqueue(async () => {
      remember(desired ? 'on' : 'off');
      try {
        const result = await reconcile(await request('cart.js'));
        await render(result.cart);
        notice('');
      } catch {
        remember(previousChoice);
        input.checked = previous;
        notice(config.dataset.error);
      } finally { busy(false); }
    });
  });
  document.addEventListener('submit', event => {
    if (!event.submitter?.matches('[name="checkout"]') || event.target.dataset.blueguardReady === 'true' || pendingTasks === 0) return;
    event.preventDefault();
    const form = event.target;
    const submitter = event.submitter;
    queue.finally(() => {
      const current = document.getElementById(form.id) || form;
      const button = Array.from(document.querySelectorAll('[name="checkout"]')).find(node => node.form === current) || submitter;
      current.dataset.blueguardReady = 'true';
      try { current.requestSubmit(button); } finally { delete current.dataset.blueguardReady; }
    });
  }, true);
  const start = () => enqueue(async () => {
    try {
      const result = await reconcile(await request('cart.js'));
      if (result.changed) await render(result.cart);
    } catch { notice(config.dataset.error); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
